import * as React from "react";
import { useState } from "react";
import { NumericTextInput } from "@/components/numeric-text-input/NumericTextInput";
import { formatAmountWithThousands } from "../lib/rebateAmountUtils";

interface Props {
  value: string;
  onValueChange: (value: string) => void;
  onBlur: () => void;
  disabled?: boolean;
  /** The field is captioned by FieldCaption, which is not a <label>, so the input names itself. */
  ariaLabel: string;
}

/**
 * Amount field that reads back with a thousands separator, and holds the
 * plain number while it is being edited. NumericTextInput turns down a
 * value holding a space, so a separator that stayed put would leave the
 * field unable to take the next keystroke.
 */
export const RebateAmountInput: React.FC<Props> = ({
  value,
  onValueChange,
  onBlur,
  disabled,
  ariaLabel,
}) => {
  const [editing, setEditing] = useState(false);

  return (
    <NumericTextInput
      maxDecimals={2}
      disabled={disabled}
      aria-label={ariaLabel}
      value={editing ? value : formatAmountWithThousands(value)}
      onValueChange={onValueChange}
      onFocus={() => setEditing(true)}
      onBlur={() => {
        setEditing(false);
        onBlur();
      }}
    />
  );
};
